import { IconMoonStars, IconSun } from '@tabler/icons-react';
import {
  ActionIcon,
  ActionIconProps,
  useComputedColorScheme,
  useMantineColorScheme,
} from '@mantine/core';

interface ThemeSchemeToggleProps extends Partial<ActionIconProps> {
  onClick?: () => void; // Define a prop onClick para permitir a passagem de uma função
}

export const ThemeSchemeToggle = ({ onClick, ...props }: ThemeSchemeToggleProps) => {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light');
  const Icon = computedColorScheme === 'dark' ? IconSun : IconMoonStars;

  const toggleColorScheme = () => {
    setColorScheme(computedColorScheme === 'dark' ? 'light' : 'dark');
    if (onClick) {
      onClick();
    }
  };

  return (
    <ActionIcon
      aria-label="Alterar tema"
      size={50}
      color="grey"
      variant="outline"
      radius="md"
      onClick={toggleColorScheme}
      {...props}
    >
      <Icon size="66%" color="grey" />
    </ActionIcon>
  );
};
